import type { ReactNode } from 'react';
import { PS, T } from '../../lib/theme';

interface SectionFrameProps {
  title: string;
  loading: boolean;
  error: Error | null;
  children: ReactNode;
}

/** Card shell for a stats section: title + per-section loading/error states. */
export function SectionFrame({ title, loading, error, children }: SectionFrameProps) {
  return (
    <section
      style={{
        background: PS.pageSecondary,
        border: `1px solid ${PS.borderLight}`,
        borderRadius: 8,
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
      }}
    >
      <h2 style={{ ...T.subheading, margin: 0 }}>{title}</h2>
      {loading && <div style={{ ...T.caption, color: PS.textSec }}>Loading…</div>}
      {error && (
        <div
          style={{
            padding: 12,
            background: PS.errorBg,
            border: `1px solid ${PS.errorBorder}`,
            color: PS.errorText,
            borderRadius: 3,
          }}
        >
          {error.message}
        </div>
      )}
      {!loading && !error && children}
    </section>
  );
}
